package network

/**
 * URLs centralizadas de Cloud Functions.
 * Si cambia el proyecto Firebase, solo se modifica BASE_URL aquí.
 */
object CloudFunctions {
    private const val BASE_URL = "https://us-central1-smartvan-38132.cloudfunctions.net"

    const val CREAR_SESION_SPEI = "$BASE_URL/crearSesionSPEI"
    const val CREAR_SESION_OXXO = "$BASE_URL/crearSesionOxxo"
    const val CREAR_SESION_TARJETA = "$BASE_URL/crearSesionTarjeta"
    const val ENVIAR_BOLETOS = "$BASE_URL/enviarBoletos"
    const val OCUPAR_ASIENTOS_EFECTIVO = "$BASE_URL/ocuparAsientosEfectivo"
    const val CREAR_CUENTA_USUARIO = "$BASE_URL/crearCuentaUsuario"
    const val ELIMINAR_CUENTA_USUARIO = "$BASE_URL/eliminarCuentaUsuario"
    const val RESETEAR_CONTRASENA = "$BASE_URL/resetearContrasena"
    const val CONFIRMAR_PAGO_MANUAL = "$BASE_URL/confirmarPagoManual"
    const val DECLINAR_PAGO_MANUAL = "$BASE_URL/declinarPagoManual"
    const val CONFIRMAR_PAGO_EFECTIVO = "$BASE_URL/confirmarPagoEfectivo"
    const val CANCELAR_VIAJE_AVISO = "$BASE_URL/cancelarViajeConAviso"
    const val ENVIAR_SOLICITUD_FACTURA = "$BASE_URL/enviarSolicitudFacturaContador"
    const val DIAGNOSTICO_SISTEMA = "$BASE_URL/diagnosticoSistema"
    const val RESOLVER_LINK_MAPS = "$BASE_URL/resolverLinkMaps"

    /** Versión actual de la app para enviar en cada request a Cloud Functions */
    val appVersionCode: Int get() = AppConfig.VERSION_CODE
}
